import { render, staticRenderFns } from "./change-password.vue?vue&type=template&id=e9989ff0"
import script from "./change-password.vue?vue&type=script&lang=ts"
export * from "./change-password.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports